
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/appointments/[...slugs]",
      function () {
        return require("private-next-pages/appointments/[...slugs].tsx");
      }
    ]);
  